import { useState, useEffect } from 'react';
import CardMessage from 'components/card-message';
import { PullRefresh, List, Search } from 'react-vant';
import { invite, membersList, searchUser, getFans } from 'api/index';
import { debounce } from 'lodash';
import { MemberInfoType } from 'api/type';
import { useAtom } from 'jotai';
import { guildIdAtom, langAtom, masterInfoAtom } from 'store';
import { sprintf, getArgFromUrl } from 'utils/index';
import { _T, useIsEn } from '@dana/components';
import { useNavigate } from 'react-router-dom';
import './list.css';
import Nav from 'components/nav';

const MembersList: React.FC<{
  type: 'invite' | 'search';
}> = ({ type }) => {
  const [value, setValue] = useState('');
  const [list, setList] = useState<MemberInfoType[]>([]);
  const [finished, setFinished] = useState(false);
  const navigate = useNavigate();
  const [guildId] = useAtom(guildIdAtom); // 公会id
  const [guildInfo] = useAtom(masterInfoAtom);
  const [lang] = useAtom(langAtom);
  const [memberList, setMemberList] = useState<MemberInfoType[]>([]);
  const [fansList, setFansList] = useState<MemberInfoType[]>([]);
  const [memberMap, setMemberMap] = useState<any>({});
  const [fansMap, setFansMap] = useState<any>({});
  const [memberMapOver, setMemberMapOver] = useState(false);
  const isEn = useIsEn();

  const searchByFront = async (value: string) => {
    const isNumber = /^[0-9]+$/.test(value);
    const l = type === 'invite' ? fansList : memberList;
    if (isNumber) {
      const res = l.filter((item) => {
        return item.danaId.toString().includes(value) || item.nickName.includes(value);
      });
      setList(res);
    } else {
      const res = l.filter((item) => {
        return item.nickName.includes(value);
      });
      setList(res);
    }
  };

  useEffect(() => {
    if (value) {
      searchByFront(value);
    } else if (type === 'invite') {
      setList(fansList);
    } else {
      setList(memberList);
    }
  }, [value]);

  useEffect(() => {
    if (type === 'invite') {
      getF();
    }
  }, [memberMap]);

  const getData = async () => {
    const res = await membersList(guildId);
    if (res) {
      setMemberList(res);
      setMemberMap({});
      const obj: any = {};
      res.map((item) => {
        obj[item.memberId] = 1;
      });
      setMemberMap(obj);
      setMemberMapOver(true);
      if (type === 'search') {
        setList(res);
      }
    }
    setFinished(true);
  };

  const onLoadRefresh = async () => {
    await getData();
  };

  const getF = async () => {
    const res = await getFans();
    if (res) {
      const result = res.filter((item) => {
        if (!memberMap[item.memberId]) {
          return true;
        }
        return false;
      });
      setFansList(result);
      if (memberMapOver) {
        setList(result);
      }
      setFansMap({});
      const obj: any = {};
      res.map((item) => {
        obj[item.memberId] = 1;
      });
      setFansMap(obj);
    }
  };

  useEffect(() => {
    getData();

    if (lang === 'ar') {
      let inputElements: any = document.getElementsByTagName('input');
      for (let input of inputElements) {
        input.style.textAlign = 'right';
        input.style.direction = 'rtl';
      }
      let list: any = document.getElementsByClassName('rv-cell');
      for (let l of list) {
        l.style.display = 'flex';
        l.style.flexDirection = 'row-reverse';
      }
    }
  }, []);

  const ItemRender: React.FC<{
    data: MemberInfoType;
  }> = ({ data }) => {
    return (
      <CardMessage
        guildId={Number(guildId)}
        type={type}
        personData={{
          ...data,
          inviteType: 1,
        }}
      ></CardMessage>
    );
  };

  return (
    <div
      className="relative"
      style={{
        direction: isEn ? 'ltr' : 'rtl',
      }}
    >
      <Nav
        isT={true}
        title={
          type === 'invite'
            ? _T('邀请成员')
            : sprintf(_T('成员：({number})'), {
                number: guildInfo?.guildMembers,
              })
        }
      ></Nav>
      {/* <div className='flex mt-[12px] mb-[12px] mx-auto w-[351px] h-[40px] p-[8px_12px] justify-center items-center rounded-[48px] bg-[#F5F7F7]'>
            <div className='bg-cover w-[24px] h-[24px]' style={{ backgroundImage: `url(${require('asset/imgs/search.png')})` }}></div>
            <Input className='placeholder-bold' style={{
                height: '40px',
                backgroundColor: '#F5F7F7',
                color: '#333',
                fontWeight: 600
            }} placeholder={_T("Search For User Nickname/ID")} />
        </div> */}
      <Search
        clearable={false}
        leftIcon={
          <div
            className="bg-cover w-[24px] h-[24px]"
            style={{
              backgroundImage: `url(${require('asset/imgs/search.png')})`,
            }}
          ></div>
        }
        className={`mt-[12px] mb-[12px] mx-auto w-[351px] h-[40px] p-[8px_12px] ${isEn ? '' : 'rv-search-right'}`}
        style={{}}
        value={value}
        onChange={setValue}
        placeholder={_T('搜索昵称或ID')}
      />
      <div
        className={`bg-[#F2F5F5] overflow-scroll pt-[12px]`}
        style={{
          height: `${window.innerHeight - 115}px`,
        }}
      >
        {type === 'invite' && (
          <div
            className="pl-[20px] mx-auto flex justify-center items-center w-[351px] h-[44px] rounded-md bg-[#FFEDCB] text-[#FFB627] font-sans text-xs font-bold"
            dir="auto"
          >
            <div
              className="mx-[3px] bg-cover w-[18px] h-[18px] transfrom translate-x-[-60%]"
              style={{
                backgroundImage: `url(${require('asset/imgs/noice.png')})`,
                transform: isEn ? 'scaleX(1)' : 'scaleX(-1)',
              }}
            ></div>
            <div className="w-[300px]" dir="auto">
              {_T('可邀请未加入公会的粉丝进入公会')}
            </div>
          </div>
        )}
        {list && list.length > 0 && (
          <List finished={finished} onLoad={onLoadRefresh}>
            {list.map((data, i) => (
              <ItemRender key={i} data={data} />
            ))}
            <div className="w-full h-[24px]"></div>
          </List>
        )}

        {list && list.length === 0 && finished && (
          <div className="absolute left-[50%] top-[50%] transfrom translate-x-[-50%] translate-y-[-50%] mx-auto">
            <div
              className="mx-auto w-[140px] h-[140px]"
              style={{
                backgroundImage: `url(${type === 'search' ? require('asset/imgs/no-data1.png') : require('asset/imgs/no-data2.png')})`,
              }}
            ></div>
            <div
              dir="auto"
              className="text-gray-500 text-center font-sans text-sm font-[400] normal-case"
            >
              {_T('没有搜索结果')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MembersList;
